import { kmmRequest } from './kmm';

export async function requestPasswordChange(email: string): Promise<string> {
  const response = await kmmRequest(
    'requestPasswordChange',
    {
      eMail: email
    },
    false,
    false
  );

  return JSON.parse(response) as string;
}

export default requestPasswordChange;
